module.exports = __webpack_public_path__ + "img/qfcm-img5.72a522c5.png";